import React from 'react';
import "./apisEWebhooks.scss";

//Imagens:
import ImgApisEWebhooks from "../../../../assets/realtimeData/apisEWebhooks.png"
import { useTranslation } from 'react-i18next';

function ApisEWebhooks() {
  const { t } = useTranslation()
  return (
    <div className='container-apis-e-webhooks'>
      <div className='img-apis-e-webhooks'>
        <img src={ImgApisEWebhooks} alt="" srcset="" />
      </div>
      <div className='texts-apis-e-webhooks'>
        <h1>{t("realtime_data.apis_and_webhooks.title")}</h1>
        <p>{t("realtime_data.apis_and_webhooks.section_text_1")}</p>
        <p>{t("realtime_data.apis_and_webhooks.section_text_2")}</p>
        <p>{t("realtime_data.apis_and_webhooks.section_text_3")}</p>
        <p>{t("realtime_data.apis_and_webhooks.section_text_4")}</p>
      </div>
    </div>
  );
}

export default ApisEWebhooks;